import { IPartFinderFamilySearchAttribute } from 'partFinder/types';

// What the filter page lists, in the family's order: an attribute on its own, or a group with its
// attributes.
export type IPartFinderAttributeUnit =
  | { type: 'attribute'; attribute: IPartFinderFamilySearchAttribute }
  | { type: 'group'; name: string; attributes: IPartFinderFamilySearchAttribute[] };

const getGroupKey = (name: string) => name.trim().toLowerCase();

// The family setup keeps a group's attributes next to each other and compares group names
// case-insensitively, so a run of the same group name is one group.
export const getAttributeUnits = (
  attributes: IPartFinderFamilySearchAttribute[]
): IPartFinderAttributeUnit[] =>
  attributes.reduce<IPartFinderAttributeUnit[]>((units, attribute) => {
    const previous = units[units.length - 1];

    if (
      attribute.group &&
      'group' === previous?.type &&
      getGroupKey(previous.name) === getGroupKey(attribute.group)
    ) {
      previous.attributes.push(attribute);

      return units;
    }

    return [
      ...units,
      attribute.group
        ? { type: 'group', name: attribute.group, attributes: [attribute] }
        : { type: 'attribute', attribute },
    ];
  }, []);
